import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-width: 0;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const MoreButton = styled.button`
  flex-shrink: 0;

  display: flex;
  align-items: center;
  padding: 0;

  background: none;
  border: none;
  cursor: pointer;

  color: ${({ theme }) => theme.palette.text.secondary};
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  line-height: 1;
  transition: ${({ theme }) => theme.transitions.create('color')};

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

export const Crumb = styled.span`
  flex-shrink: 1;
  min-width: 0;

  ${({ theme }) => typographyToCss(theme.typography.caption)};

  & > a {
    display: flex;
    align-items: center;
    min-width: 0;

    text-decoration: none;
    color: inherit;
    transition: ${({ theme }) => theme.transitions.create('color')};

    &:hover {
      color: ${({ theme }) => theme.palette.text.primary};
      text-decoration: underline;
    }
  }
`;

export const CrumbName = styled.span`
  min-width: 0;
  max-width: 24rem;
  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Current = styled.span`
  flex-shrink: 1;
  min-width: 2rem;
  overflow: hidden;

  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  color: ${({ theme }) => theme.palette.text.primary};

  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const IconWrapper = styled.span`
  margin-right: ${({ theme }) => theme.spacing(1)};

  display: flex;
  align-items: center;
`;

export const Separator = styled.span`
  flex-shrink: 0;

  display: flex;
  align-items: center;

  color: ${({ theme }) => theme.palette.grey[600]};
  user-select: none;
`;
